export default __webpack_public_path__ + "static/media/2.421add9d.jpg";